import axios from 'axios';
import { observable } from 'mobx';
import { setItemLocalStorage } from './tool/storage/storage';

class ToolSettingStore {
  @observable accessor toolSettings = {};

  constructor() {
    this.getAdvisorSearchUrl = this.getAdvisorSearchUrl.bind(this);
  }

  async getAdvisorSearchUrl() {
    const toolSettings = await axios('/tool-settings');

    this.toolSettings.advisorSearchUrl = toolSettings.data.advisorSearchUrl;
    this.toolSettings.colorChart = toolSettings.data.colorChart;
    this.toolSettings.colorBackgroundChart = toolSettings.data.colorBackgroundChart;
    this.toolSettings.colorXAxisChart = toolSettings.data.colorXAxisChart;

    setItemLocalStorage(this.toolSettings, 'LooptijdRenteToolSettings');
  }
}

const ToolSettingData = new ToolSettingStore();

export default ToolSettingData;
